import { api } from './api';

export interface Linha {
  id: number;
  nome: string;
  ativo: 'SIM' | 'NAO';
}

export interface LinhaRequest {
  id?: number;
  nome: string;
  ativo: 'SIM' | 'NAO';
}

export const linhaService = {
  // Buscar todas as linhas
  getAll: async (): Promise<Linha[]> => {
    const response = await api.get<Linha[]>('/api/Linha/GetAll');
    return response.data;
  },

  // Buscar linha por ID
  getById: async (id: number): Promise<Linha> => {
    const response = await api.get<Linha>(`/api/Linha/GetById?id=${id}`);
    return response.data;
  },

  // Salvar nova linha
  save: async (linha: LinhaRequest): Promise<Linha> => {
    const response = await api.post<Linha>('/api/Linha/Salvar', linha);
    return response.data;
  },

  // Alterar linha existente
  update: async (linha: LinhaRequest): Promise<Linha> => {
    const response = await api.post<Linha>('/api/Linha/Alterar', linha);
    return response.data;
  },
};
